// extracted by mini-css-extract-plugin
export default {"Sauces":"Sauces_Sauces__6YEaQ","Sauces__toggle":"Sauces_Sauces__toggle__1_4wo","Sauces__toggle-arrow":"Sauces_Sauces__toggle-arrow__2rhfm"};